import SelectionCheckmarkBadgeIcon from "@homeinstead/icons/SelectionCheckmarkBadge";
import { cn } from "@homeinstead/ui";

function SelectedCheckmark() {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "motion-safe:animate-selection-checkmark-enter",
        "motion-reduce:animate-none",
      )}
    >
      <SelectionCheckmarkBadgeIcon
        className={cn(
          "size-6",
          "motion-safe:[&_path]:animate-selection-checkmark-draw",
          "motion-reduce:[&_path]:animate-none",
        )}
        data-testid="selected-checkmark"
      />
    </div>
  );
}

export { SelectedCheckmark };
